import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { CheckboxLabel } from "@/sx-layout/common/Form/CheckboxLabel";
import { MachineIcon } from "@/sx-layout/common/MachineIcon";
import { ColorPicker } from "@/sx-layout/components/plotmap/components/freeDraw/components/ColorPicker";
import { useUserCompanyColor } from "@/sx-layout/hooks/useUserCompanyColor";
import { normalizeHexColor } from "@/sx-layout/utils";

type Props = {
  iconId: number;
  iconSetting: {
    machine_icon_id: number;
    icon_color: string;
  };
  onChange: (color?: string) => void;
};

export const IconColorItem = ({ iconId, iconSetting, onChange }: Props) => {
  const { t } = useTranslation();
  const { loginUserCompanyIconColor } = useUserCompanyColor();

  const [customColorFlg, setCustomColorFlg] = useState<boolean>(!!iconSetting);
  const [color, setColor] = useState(iconSetting?.icon_color);

  useEffect(() => {
    setCustomColorFlg(!!iconSetting);
    setColor(iconSetting?.icon_color);
  }, [iconSetting]);

  const handleChangeFlg = (flg: boolean) => {
    setCustomColorFlg(flg);
    if (flg) {
      onChange(loginUserCompanyIconColor);
    } else {
      onChange();
    }
  };

  const handleChangeColor = (color: string) => {
    setColor(color);
    onChange(color);
  };

  return (
    <div className="flex items-center gap-[12px]">
      {/* 重機アイコン */}
      <MachineIcon
        machineIconId={iconId}
        shapeColor={normalizeHexColor(color) ?? "#000"}
        active={true}
        selected={false}
        outline={false}
        className="w-[50px] h-[50px] gap-[12px]"
      />
      {/* 個別着色 */}
      <CheckboxLabel label={t("coloring")} value={customColorFlg} onChange={handleChangeFlg} />
      {/* 個別色選択 */}
      {customColorFlg && (
        <ColorPicker
          value={normalizeHexColor(color ?? loginUserCompanyIconColor)}
          onChange={handleChangeColor}
          hideInput={true}
        />
      )}
    </div>
  );
};
